<template>
  <section id="pricing" class="container">
    <div class="header">
      <span class="category">{{ t('pricing_category') }}</span>
      <h2>{{ t('pricing_h2') }}</h2>
      <p>{{ t('pricing_p') }}</p>
    </div>

    <IntervalToggle :interval="interval" @updateInterval="updateInterval" />

    <!-- <table>
      <tr>
        <th></th>
        <th>
          <span>{{ t('Individuell') }}</span>
        </th>
        <th>
          <span>{{ t('Growth') }}</span>
        </th>
      </tr>

      <tr>
        <td>{{ t('Users') }}</td>
        <td>1</td>
        <td>3</td>
      </tr>

      <tr>
        <td>{{ t('Generator Tokens') }}</td>
        <td>1.000</td>
        <td>5.000</td>
      </tr>

      <tr>
        <td>{{ t('Email Tokens') }}</td>
        <td>1.000</td>
        <td>5.000</td>
      </tr>

      <tr>
        <td>{{ t('Tracking Functionality') }}</td>
        <td><i class="fa-solid fa-check"></i></td>
        <td><i class="fa-solid fa-check"></i></td>
      </tr>

      <tr>
        <td>{{ t('Connect via SMTP') }}</td>
        <td><i class="fa-solid fa-check"></i></td>
        <td><i class="fa-solid fa-check"></i></td>
      </tr>

      <tr>
        <td>{{ t('IMAP Tracking') }}</td>
        <td><i class="fa-solid fa-check"></i></td>
        <td><i class="fa-solid fa-check"></i></td>
      </tr>

      <tr>
        <td>{{ t('Smart Inbox Rotate') }}</td>
        <td><i class="fa-solid fa-x"></i></td>
        <td><i class="fa-solid fa-check"></i></td>
      </tr>

      <tr>
        <td>{{ t('API Access') }}</td>
        <td><i class="fa-solid fa-x"></i></td>
        <td><i class="fa-solid fa-check"></i></td>
      </tr>

      <tr>
        <td>{{ t('Price') }}</td>
        <td>€0</td>
        <td>{{ interval === 'monthly' ? '€100 / Month' : '€1.000 / Year' }}</td>
      </tr>
    </table> -->

    <div class="plans__container row">
      <Plan v-for="p in plans" :plan="p" :key="p" :interval="interval" />
    </div>
  </section>
</template>

<script>
import { ref } from 'vue'

import IntervalToggle from './components/IntervalToggle.vue'
import Plan from './components/Plan.vue'

export default {
  name: 'Pricing',
  components: { IntervalToggle, Plan },
  setup() {
    const interval = ref('monthly')

    const updateInterval = () => {
      if (interval.value === 'monthly') interval.value = 'annual'
      else interval.value = 'monthly'
    }

    const plans = [
      {
        icon: 'fa-solid fa-user',
        name: 'Individuell',
        description: 'pricing_free_desc',
        color: '',
        price: {
          monthly: 0,
          annual: 0,
        },
        button: 'register',
        features: [
          { name: 'plan_users', value: 1, description: 'plan_users_desc' },
          {
            name: 'plan_generator_tokens',
            value: '1.000',
            description: 'plan_generator_tokens_desc',
          },
          {
            name: 'plan_sending_tokens',
            value: '1.000',
            description: 'plan_sending_tokens_desc',
          },
          { name: 'plan_email_tracking', description: 'plan_email_tracking_desc' },
          { name: 'plan_smtp', description: 'plan_smtp_desc', value: '3' },
        ],
      },
      {
        icon: 'fa-solid fa-bolt',
        name: 'Growth',
        description: 'pricing_starter_desc',
        color: '',
        price: {
          monthly: 100,
          annual: '1.000',
        },
        button: 'register',
        features: [
          { name: 'plan_users', value: 3, description: 'plan_users_desc' },
          {
            name: 'plan_generator_tokens',
            value: '5.000',
            description: 'plan_generator_tokens_desc',
          },
          {
            name: 'plan_sending_tokens',
            value: '5.000',
            description: 'plan_sending_tokens_desc',
          },
          { name: 'plan_email_tracking', description: 'plan_email_tracking_desc' },
          { name: 'plan_smtp', description: 'plan_smtp_desc', value: '15' },
          { name: 'plan_api', description: 'plan_api_desc' },
          { name: 'Deliverability', description: 'Smart Inbox Rotate' },
        ],
      },
      {
        icon: 'fa fa-school',
        name: 'Academy',
        description: 'pricing_academy_description',
        color: '',
        price: {
          monthly: '1.000',
          annual: '10.000',
        },
        button: 'contact',
        features: [
          { name: 'plan_implement', description: 'plan_implement_desc' },
          { name: 'plan_analyse', description: 'plan_analyse_desc' },
        ],
      },
    ]

    return {
      interval,
      updateInterval,
      plans,
    }
  },
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  max-width: 700px;
  margin-top: 50px;
  border-collapse: collapse;

  th,
  td {
    text-align: center;
    border: 1px solid var(--font);
    padding: 5px 0;

    &:first-of-type {
      text-align: start;
    }
  }

  tr:first-child th,
  tr:first-child td {
    border-top: none;
  }

  tr:last-child th,
  tr:last-child td {
    border-bottom: none;
  }

  th:first-of-type,
  td:first-of-type {
    border-left: none;
  }

  th:last-of-type,
  td:last-of-type {
    border-right: none;
  }
}

.plans__container {
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 50px auto 0 auto;
}

.trial {
  max-width: 300px;
  text-align: center;
  font-size: 0.85rem;
  color: var(--dark-6);
  font-style: italic;
  line-height: 20px;
}
</style>
